"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectableTextInput = void 0;
const react_1 = __importStar(require("react"));
const public_1 = require("../../common/public");
const Dropdown_1 = require("../Dropdown");
const helpers_1 = require("../../helpers");
const getStylesWithMaxWidth_1 = require("../../helpers/getStylesWithMaxWidth");
const Suggest_1 = require("../../Suggest");
const useControlState_1 = require("../helpers/useControlState");
const defaultControlRenderer_1 = require("./controls/defaultControlRenderer");
exports.SelectableTextInput = (0, helpers_1.createUIElement)('SelectableTextInput', (_a, ref) => {
    var { className, size = public_1.CONTROL_SIZE.s, disabled = false, error = false, data, value, hasEnterKeyStopPropagation, placeholder, onChange, optionContainerRenderer = (0, Suggest_1.createOptionContainerRenderer)(), onMenuOpen, onMenuClose, isOptionDisabled, virtualListWidth, virtualListLimit, preventInputValue, onFocus, onBlur, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "size", "disabled", "error", "data", "value", "hasEnterKeyStopPropagation", "placeholder", "onChange", "optionContainerRenderer", "onMenuOpen", "onMenuClose", "isOptionDisabled", "virtualListWidth", "virtualListLimit", "preventInputValue", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    const dataSelectorId = rest['data-selector-id'] || 'selectable-text-input';
    const rootRef = (0, react_1.useRef)(null);
    const inputRef = ref || rootRef;
    const { focused, active, activate, preventBlur, input } = (0, useControlState_1.useControlState)({
        rootRef: inputRef,
        onBlur,
        onFocus
    });
    const selectedIndex = value ? data.indexOf(value) : -1;
    const [control] = (0, Dropdown_1.useDropdown)({
        offset: 1,
        renderControl: ({ button, actions: dropdownActions, isActive }) => {
            const actions = {
                open: () => {
                    if (disabled || isActive) {
                        return;
                    }
                    dropdownActions === null || dropdownActions === void 0 ? void 0 : dropdownActions.show();
                    activate();
                },
                close: () => {
                    if (disabled || !isActive) {
                        return;
                    }
                    dropdownActions === null || dropdownActions === void 0 ? void 0 : dropdownActions.hide();
                    activate();
                }
            };
            return (0, defaultControlRenderer_1.createDefaultControl)({ inputRef })(Object.assign(Object.assign({}, rest), { className: `vm-SelectableTextInput ${className}`, testId: dataSelectorId, error: !!error, size, disabled: !!disabled, active, opened: isActive, actions,
                focused, value: value || '', hasEnterKeyStopPropagation,
                placeholder, control: {
                    ref: button.ref,
                    preventInputValue,
                    onChange,
                    onBlur: input.onBlur,
                    onFocus: input.onFocus,
                    onKeyDown: (e) => {
                        actions.close();
                        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
                    },
                    onMouseDown: (e) => {
                        e === null || e === void 0 ? void 0 : e.stopPropagation();
                        onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
                    },
                    onMouseUp,
                    onClick,
                    onMouseEnter,
                    onMouseLeave,
                    onKeyUp,
                    onKeyPress,
                    style
                } }));
        },
        renderPopover: ({ actions, popover }) => {
            const suggestStyle = (0, getStylesWithMaxWidth_1.getStylesWithMaxWidth)(popover.style);
            const suggestVirtualListWidth = virtualListWidth ||
                (typeof (suggestStyle === null || suggestStyle === void 0 ? void 0 : suggestStyle.minWidth) === 'number'
                    ? suggestStyle === null || suggestStyle === void 0 ? void 0 : suggestStyle.minWidth
                    : undefined);
            return (react_1.default.createElement(Suggest_1.Suggest, { "data-selector-id": `${dataSelectorId}-menu`, ref: popover.ref, selectedIndex: selectedIndex, textGetter: (item) => item, onSelect: (item, idx) => {
                    onChange === null || onChange === void 0 ? void 0 : onChange(item);
                    actions.hide();
                }, onMouseDown: preventBlur, optionContainerRenderer: optionContainerRenderer, isOptionDisabled: isOptionDisabled, data: data, style: suggestStyle, hasVirtualization: true, virtualListWidth: suggestVirtualListWidth, virtualListLimit: virtualListLimit }));
        },
        onDidHide: onMenuClose,
        onDidShow: onMenuOpen,
        dropdownWidth: Dropdown_1.DROPDOWN_WIDTH.minControlWidthAndMaxXXL
    });
    return control;
});
//# sourceMappingURL=SelectableTextInput.js.map